(() => {
  const host = document.querySelector('[data-agfn-halloween]');
  if (!host || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;

  const dialog = host.querySelector('[data-agfn-dialog]');
  const open = host.querySelector('[data-agfn-open]');
  const close = host.querySelector('[data-agfn-close]');
  const quantity = host.querySelector('[data-agfn-count]');
  const same = host.querySelector('[data-agfn-same]');
  const sameRow = host.querySelector('[data-agfn-same-row]');
  const selection = host.querySelector('[data-agfn-selection]');
  const rules = window.AGFNHalloweenNoteRules;
  const notes = host.querySelector('[data-agfn-notes]');
  const subtotal = host.querySelector('[data-agfn-subtotal]');
  const preview = host.querySelector('[data-agfn-preview-note]');
  const previewCaption = host.querySelector('[data-agfn-preview-caption]');
  const error = host.querySelector('[data-agfn-error]');
  const cartLink = host.querySelector('[data-agfn-cart-link]');
  const submit = host.querySelector('[data-agfn-submit]');
  const productForm = host.closest('form[action*="/cart/add"]') || host.closest('form');
  const addonId = Number(host.dataset.addonVariantId);
  const addonPrice = Number(host.dataset.addonPriceCents);
  const initialId = Number(host.dataset.initialVariantId);
  const variants = JSON.parse(host.querySelector('[data-agfn-variants]').textContent);
  if (!productForm || !rules || host.dataset.currency !== 'USD' || !Number.isSafeInteger(addonId) || addonPrice !== 1000) return;

  const root = window.Shopify?.routes?.root || '/';
  let entries = [''];
  let activeCount = 1;
  let sharedNote = '';
  let opened = false;
  let submitting = false;
  let activeIndex = 0;
  let selectedVariant = null;
  const wordCount = rules.words;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:'USD'}).format(cents / 100);
  const clean = rules.clean;
  const showError = (message, reviewCart = false) => {
    error.textContent = message;
    error.hidden = !message;
    cartLink.hidden = !reviewCart;
  };

  function refreshVariant() {
    const id = Number(productForm.querySelector('input[name="id"]')?.value || initialId);
    const record = variants[id];
    selectedVariant = Number.isSafeInteger(id) && record && Number.isSafeInteger(record.price) && record.available
      ? {id, price: record.price, title:record.title}
      : null;
    host.hidden = !selectedVariant;
    updateSubtotal();
  }
  function selectedPurchase() {
    // Appstle uses two radios with the same name; the first is always one-time.
    // Read the checked control rather than the first matching input.
    const controls = [...productForm.querySelectorAll('[name="selling_plan"]')];
    const field = controls.find(node => (node.type === 'radio' || node.type === 'checkbox') && node.checked)
      || controls.find(node => node.type !== 'radio' && node.type !== 'checkbox');
    const raw = String(field?.value || '');
    const id = /^\d+$/.test(raw) && Number(raw) > 0 ? Number(raw) : null;
    const allocation = id && selectedVariant ? variants[selectedVariant.id]?.sellingPlans?.[id] : null;
    return {id, allocation};
  }
  function updateSubtotal() {
    if (!selectedVariant) return;
    const count = activeCount;
    selection.textContent = selectedVariant.title === 'Default Title' ? host.dataset.productTitle : selectedVariant.title;
    const purchase = selectedPurchase();
    if (purchase.id) {
      const plan = purchase.allocation;
      const jarPrice = plan && Number.isSafeInteger(plan.price) ? plan.price : null;
      subtotal.textContent = jarPrice === null
        ? `${count} subscription ${count === 1 ? 'jar' : 'jars'} · ${money(count * addonPrice)} personalization for the first order only. Jar subscription price is confirmed in your cart.`
        : `${count} personalized ${count === 1 ? 'jar' : 'jars'} · ${money(count * (jarPrice + addonPrice))} first-order product subtotal, including ${money(count * addonPrice)} personalization. ${plan.name}. The note and its fee do not repeat.`;
    } else {
      subtotal.textContent = `${count} personalized ${count === 1 ? 'jar' : 'jars'} · ${money(count * (selectedVariant.price + addonPrice))} product subtotal (includes ${money(count * addonPrice)} personalization)`;
    }
    submit.textContent = `Add ${count} personalized ${count === 1 ? 'jar' : 'jars'} to cart`;
  }
  function paintPreview() {
    if (!preview || !previewCaption) return;
    const text = clean(entries[activeIndex] || '');
    preview.textContent = text || 'YOUR MESSAGE GOES HERE';
    previewCaption.textContent = `Previewing jar ${activeIndex + 1} of ${entries.length}`;
  }
  function paintFields() {
    notes.replaceChildren();
    const values = same.checked ? [sharedNote] : entries.slice(0, activeCount);
    values.forEach((value, index) => {
      const wrap = document.createElement('div');
      wrap.className = 'agfn-halloween__note-wrap';
      const label = document.createElement('label');
      label.className = 'agfn-halloween__note-label';
      label.htmlFor = `agfn-note-${index}`;
      label.textContent = same.checked ? `Your note for all ${activeCount} jars` : `Jar ${index + 1} — your note`;
      const field = document.createElement('textarea');
      field.id = label.htmlFor;
      field.maxLength = 80;
      field.required = true;
      field.setAttribute('aria-describedby', `agfn-count-${index} agfn-field-error-${index} agfn-halloween-limits`);
      field.value = value;
      field.placeholder = 'A little spooky message for someone special';
      const count = document.createElement('span');
      count.className = 'agfn-halloween__note-count';
      count.id = `agfn-count-${index}`;
      const fieldError = document.createElement('span');
      fieldError.id = `agfn-field-error-${index}`;
      fieldError.className = 'agfn-halloween__field-error';
      fieldError.setAttribute('aria-live', 'polite');
      const update = () => {
        if (same.checked) sharedNote = field.value; else entries[index] = field.value;
        const problem = field.value ? rules.error(field.value) : '';
        fieldError.textContent = problem;
        fieldError.hidden = !problem;
        field.setAttribute('aria-invalid', String(Boolean(problem)));
        count.textContent = `${wordCount(field.value)}/12 words · ${field.value.length}/80 characters`;
        count.style.color = wordCount(field.value) > 12 ? '#8a2516' : '';
        if (index === activeIndex) paintPreview();
      };
      field.addEventListener('focus', () => {activeIndex = index; paintPreview();});
      field.addEventListener('input', update);
      update();
      wrap.append(label, field, count, fieldError);
      notes.append(wrap);
    });
    updateSubtotal();
    paintPreview();
  }
  function setCount(raw) {
    const count = Number(raw);
    if (!Number.isInteger(count) || count < 1 || count > 20) {showError('Choose between 1 and 20 personalized jars.'); return;}
    showError('');
    while (entries.length < count) entries.push('');
    activeCount = count;
    sameRow.hidden = count < 2;
    activeIndex = Math.min(activeIndex, count - 1);
    quantity.value = String(count);
    paintFields();
  }
  same.addEventListener('change', () => {
    if (same.checked) sharedNote = entries[0] || '';
    showError('');
    paintFields();
    notes.querySelector('textarea')?.focus();
  });
  function requestCart(path, body) {
    // Use the storefront's normal XHR adapters with explicit per-jar plan data.
    // Each merchandise request contains one jar to avoid app batch rewriting.
    // Keep the normal app adapters active; do not replace window.fetch or skip apps.
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(body ? 'POST' : 'GET', root + 'cart' + (path ? '/' + path : '') + '.js');
      request.withCredentials = true;
      request.timeout = 20000;
      request.setRequestHeader('Accept', 'application/json');
      if (body) request.setRequestHeader('Content-Type', 'application/json');
      request.onload = () => {
        if (request.status < 200 || request.status >= 300) {reject(Error('CART_REQUEST_FAILED_' + request.status)); return;}
        try {resolve(JSON.parse(request.responseText));} catch {reject(Error('CART_INVALID_RESPONSE'));}
      };
      request.onerror = () => reject(Error('CART_NETWORK_ERROR'));
      request.onabort = () => reject(Error('CART_REQUEST_ABORTED'));
      request.ontimeout = () => reject(Error('CART_REQUEST_TIMEOUT'));
      // A timed-out POST may have succeeded. Reconcile/rollback; never retry an add blindly.
      request.send(body ? JSON.stringify(body) : null);
    });
  }
  const postCart = (path, body) => requestCart(path, body);
  const readCart = () => requestCart('');
  function findParents(cart, refs, variantId) {
    return refs.map(ref => {
      const matches = cart.items.filter(item => item.variant_id === variantId && item.quantity === 1 && item.properties?.['_AGFN jar ref'] === ref);
      if (matches.length !== 1 || !matches[0].key) throw Error('PARENT_LINE_NOT_UNIQUE');
      return matches[0];
    });
  }
  async function rollback(refs, variantId) {
    const cart = await readCart();
    const ownedParents = cart.items.filter(item => item.variant_id === variantId && refs.includes(item.properties?.['_AGFN jar ref']));
    if (ownedParents.length) {
      const updates = Object.fromEntries(ownedParents.map(item => [item.key, 0]));
      await postCart('update', {updates});
    }
    const after = await readCart();
    return !after.items.some(item => refs.includes(item.properties?.['_AGFN jar ref']));
  }

  const exampleDialog = document.querySelector('[data-agfn-example-dialog]');
  const motionToggle = host.querySelector('[data-agfn-motion-toggle]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionEnabled = host.dataset.batMotion === 'true';
  let motionPaused = false;
  let visible = false;
  let idleTimer = null;
  let flightTimer = null;
  function stopIdle() {
    clearInterval(idleTimer);
    idleTimer = null;
  }
  function flyBats() {
    if (!motionEnabled || motionPaused || reducedMotion.matches || document.hidden || !visible || dialog.open || exampleDialog?.open) return;
    if (open.classList.contains('is-bat-flight')) return;
    open.classList.add('is-bat-flight');
    clearTimeout(flightTimer);
    flightTimer = setTimeout(() => open.classList.remove('is-bat-flight'), 950);
  }
  function syncMotion() {
    stopIdle();
    motionToggle.hidden = !motionEnabled || reducedMotion.matches;
    if (!motionEnabled || motionPaused || reducedMotion.matches || document.hidden || !visible || dialog.open || exampleDialog?.open) {
      open.classList.remove('is-bat-flight');
      return;
    }
    idleTimer = setInterval(flyBats, 4000);
  }
  if (typeof IntersectionObserver !== 'undefined') {
    new IntersectionObserver(records => {
      visible = records[0].isIntersecting;
      syncMotion();
    }, {threshold: 0.15}).observe(open);
  } else {visible = true;}
  reducedMotion.addEventListener('change', syncMotion);
  document.addEventListener('visibilitychange', syncMotion);
  open.addEventListener('mouseenter', flyBats);
  open.addEventListener('focus', flyBats);
  motionToggle.addEventListener('click', () => {
    motionPaused = !motionPaused;
    motionToggle.setAttribute('aria-pressed', String(motionPaused));
    motionToggle.textContent = motionPaused ? 'Resume bat animation' : 'Pause bat animation';
    syncMotion();
  });
  document.addEventListener('agfn-example-change', syncMotion);
  dialog.addEventListener('close', () => {entries = entries.slice(0, activeCount); if (!submitting) open.focus(); syncMotion();});

  open.addEventListener('click', () => {
    refreshVariant();
    if (!selectedVariant) return;
    const sourceQuantity = productForm.querySelector('input[name="quantity"]');
    if (!opened) setCount(sourceQuantity?.value || quantity.value || 1);
    else setCount(activeCount);
    opened = true;
    dialog.showModal();
    syncMotion();
    notes.querySelector('textarea')?.focus();
  });
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
  productForm.addEventListener('change', () => queueMicrotask(refreshVariant));
  quantity.addEventListener('input', () => setCount(quantity.value));
  quantity.addEventListener('change', () => setCount(quantity.value));
  submit.addEventListener('click', async event => {
    event.preventDefault();
    if (submitting) return;
    showError('');
    const count = Number(quantity.value);
    if (!Number.isInteger(count) || count < 1 || count > 20 || count !== activeCount) {showError('Choose between 1 and 20 personalized jars.'); return;}
    const cleaned = Array.from({length:count}, (_,index) => clean(same.checked ? sharedNote : entries[index]));
    const bad = cleaned.findIndex(text => Boolean(rules.error(text)));
    if (bad >= 0) {activeIndex = bad; notes.querySelectorAll('textarea')[same.checked ? 0 : bad]?.focus(); showError(`Jar ${bad + 1}: ${rules.error(cleaned[bad])}`); return;}
    refreshVariant();
    if (!selectedVariant) {showError('Choose an available jar option before customizing.'); return;}
    const purchase = selectedPurchase();

    const variantId = selectedVariant.id;
    const refs = cleaned.map(() => crypto.randomUUID());
    let addedCart = null;
    let finishAdd = null;
    submitting = true;
    submit.disabled = true;
    submit.textContent = 'Adding your jars…';
    try {
      finishAdd = window.AGFNHalloweenCart.beginAdd();
      if ((await readCart()).currency !== 'USD') throw Error('USD_REQUIRED');
      // Real subscription adapters can collapse repeated variant IDs in a batch.
      // Add each jar separately, then attach the one-time fees by exact parent key.
      // Never copy the note text onto the recurring merchandise line.
      for (const ref of refs) {
        await postCart('add', {items: [{
          id: variantId, quantity: 1,
          ...(purchase.id ? {selling_plan: purchase.id} : {}),
          properties: {'_AGFN jar ref': ref},
        }]});
      }
      const parents = findParents(await readCart(), refs, variantId);
      if (parents.some(parent => (parent.selling_plan_allocation?.selling_plan?.id || null) !== purchase.id)) throw Error('SELLING_PLAN_CHANGED');
      // Only jars have a selling plan. The fee and its note are one-time items.
      // Parent line keys, unlike a variant ID, identify each jar unambiguously.
      await postCart('add', {items: parents.map((parent, index) => ({
        id: addonId, quantity: 1, parent_line_key: parent.key,
        properties: {'Halloween note': cleaned[index], '_AGFN jar ref': refs[index]},
      }))});
      const cart = await readCart();
      for (const [index] of parents.entries()) {
        const currentParent = findParents(cart, [refs[index]], variantId)[0];
        if (currentParent.properties?.['Halloween note']) throw Error('NOTE_ON_UNPAID_LINE');
        if ((currentParent.selling_plan_allocation?.selling_plan?.id || null) !== purchase.id) throw Error('SELLING_PLAN_CHANGED');
        const children = cart.items.filter(item => item.variant_id === addonId && item.properties?.['_AGFN jar ref'] === refs[index] && item.parent_relationship?.parent_key === currentParent.key);
        if (children.length !== 1 || children[0].quantity !== 1 || children[0].original_price !== addonPrice || children[0].selling_plan_allocation || children[0].properties?.['Halloween note'] !== cleaned[index]) throw Error('ADDON_READBACK_FAILED');
      }
      addedCart = cart;
    } catch (failure) {
      // Codes only: never log the customer's message, cart token or line identities.
      console.warn('[AGFN Halloween] ' + failure.message);
      let rolledBack = false;
      try {rolledBack = await rollback(refs, variantId);} catch { /* Cart state is uncertain; let the customer inspect it. */ }
      showError(rolledBack
        ? 'We could not add the personalized jars. Nothing was added; please try again.'
        : 'We could not verify the personalized jars. Review your cart before trying again.', !rolledBack);
      submit.disabled = false;
      updateSubtotal();
    } finally {
      finishAdd?.();
    }
    if (!addedCart) {submitting = false; return;}
    // Cart writes are already verified. A drawer-render failure must never
    // roll back a paid note or encourage the customer to repeat this batch.
    entries = [''];
    sharedNote = '';
    same.checked = false;
    opened = false;
    setCount(1);
    // Finish the native dialog's close/focus lifecycle before opening the drawer.
    if (dialog.open) await new Promise(resolve => {
      dialog.addEventListener('close', resolve, {once:true});
      dialog.close();
    });
    try {
      await window.AGFNHalloweenCart.open(addedCart);
      submit.disabled = false;
    } catch {
      showError('Your jars and notes were added. Open your cart to review them before adding more.', true);
      submit.disabled = true;
      dialog.showModal();
      cartLink.focus();
    } finally {
      submitting = false;
    }
  });
  refreshVariant();
  syncMotion();
})();
